<div class="login-page">
  <div class="login-page-outer">
    <div class="login-page-inner">
      <div class="logo">
        <h2>
          <img src="Logo.png" alt="img" width="200px" srcset="">
        </h2>
      </div>
      <!-- SIGN IN PAGE -->
      @if(isSignInMode) {
      <div class="login-form-wrapper">
        <h5>Let's Get Started!</h5>
        <p class="mt-1">
          Please fill the below details to Sign In your account.
        </p>
        <div class="card login-form mt-3">
          <!-- SIGN IN FORM -->
          <form
            [formGroup]="LoginForm"
            (ngSubmit)="onLoginSubmit()"
            class="form-holder mt-2"
          >
            <div>
              <label for="userName" class="form-label">User Name</label>
              <div class="input-group">
                <span class="input-group-icon">
                  <i class="bi bi-envelope"></i>
                </span>
                <input
                  type="text"
                  class="input"
                  id="userName"
                  autocomplete="off"
                  placeholder="User Name"
                  formControlName="userName"
                  class="form-control"
                />
              </div>
            </div>
            <div>
              <label for="password" class="form-label">Password</label>
              <div class="input-group">
                <span class="input-group-icon">
                  <i class="bi bi-lock"></i>
                </span>
                <input
                  type="password"
                  id="password"
                  class="input"
                  placeholder="Password"
                  formControlName="password"
                  class="form-control"
                />
              </div>
            </div>
            <button type="submit" class="btn btn-primary w-100 mt-3">
              Sign In
            </button>
            <p class="text-center mt-3 sign-link-text">
              Don't have an account?
              <span (click)="toggleSignInMode()">Sign Up</span>
            </p>
          </form>
        </div>
      </div>
      } @if(!isSignInMode) {
      <!-- SIGN UP PAGE -->
      <div class="login-form-wrapper">
        <h5>Let's Get Started!</h5>
        <p class="mt-1">
          Please fill the below details to Sign Up your account.
        </p>
        <div class="card login-form mt-3">
          <form
            [formGroup]="registerForm"
            (ngSubmit)="onRegisterSubmit()"
            class="form-holder"
          >
            <div>
              <label for="firstName" class="form-label">First Name</label>
              <div class="input-group">
                <span class="input-group-icon">
                  <i class="bi bi-person"></i>
                </span>
                <input
                  type="text"
                  class="input"
                  placeholder="First Name"
                  autocomplete="off"
                  formControlName="firstName"
                  class="form-control"
                />
              </div>
            </div>
            <div>
              <label for="lastName" class="form-label">Last Name</label>
              <div class="input-group">
                <span class="input-group-icon">
                  <i class="bi bi-person"></i>
                </span>
                <input
                  type="text"
                  class="input"
                  placeholder="Last Name"
                  autocomplete="off"
                  formControlName="lastName"
                  class="form-control"
                />
              </div>
            </div>
            <div>
              <label for="userName" class="form-label">User Name</label>
              <div class="input-group">
                <span class="input-group-icon">
                  <i class="bi bi-person-check"></i>
                </span>
                <input
                  type="text"
                  class="input"
                  placeholder="Username"
                  autocomplete="off"
                  formControlName="userName"
                  class="form-control"
                />
              </div>
            </div>
            <div>
              <label for="email" class="form-label">Email</label>
              <div class="input-group">
                <span class="input-group-icon">
                  <i class="bi bi-envelope"></i>
                </span>
                <input
                  type="email"
                  class="input"
                  autocomplete="off"
                  placeholder="Email"
                  formControlName="email"
                  class="form-control"
                />
              </div>
            </div>
            <div>
              <label for="password" class="form-label">Password</label>
              <div class="input-group">
                <span class="input-group-icon">
                  <i class="bi bi-lock"></i>
                </span>
                <input
                  type="password"
                  class="input"
                  placeholder="Password"
                  formControlName="password"
                  class="form-control"
                />
              </div>
            </div>
            <div>
              <label for="password" class="form-label">Confirm Password</label>
              <div class="input-group">
                <span class="input-group-icon">
                  <i class="bi bi-lock"></i>
                </span>
                <input
                  type="password"
                  class="input"
                  placeholder="Confirm Password"
                  formControlName="repeatPassword"
                  class="form-control"
                />
              </div>
            </div>
            <button type="submit" class="btn btn-primary w-100 mt-3">
              Sign Up
            </button>
            <p class="text-center mt-3 sign-link-text">
              Already have an account?
              <span (click)="toggleSignInMode()">Sign In</span>
            </p>
          </form>
        </div>
      </div>
      }
    </div>
    <div class="ripple-background">
      <div class="circle xxlarge shade1"></div>
      <div class="circle xlarge shade2"></div>
      <div class="circle large shade3"></div>
      <div class="circle mediun shade4"></div>
      <div class="circle small shade5"></div>
    </div>
  </div>
  <div class="w-50 login-image">

  </div>
</div>